import React, { createContext, useContext, useState } from "react";
import { toast } from 'react-toastify';
import { fetchAISmsTemplateTableAndFilterSchema } from "model/AISmsTemplateModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const AISmsTemplateContext = createContext();

export const AISmsTemplateProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [aiSmsTemplateContextData, setAISmsTemplateContextData] = useState();

    const fetchAISmsTemplateContextData = async () => {
        setLoading(true);
        try {
            const response = await fetchMetadataSchema("metadata:aiSmsTemplate", () =>
                fetchAISmsTemplateTableAndFilterSchema([])
            );
            if (response?.success) {
                setAISmsTemplateContextData(response?.data);
            }
        } catch (err) {
            toast.error(err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AISmsTemplateContext.Provider
            value={{
                fetchAISmsTemplateContextData,
                aiSmsTemplateContextData,
                loading,
                error,
            }}
        >
            {children}
        </AISmsTemplateContext.Provider>
    );
};

export const useAISmsTemplateContext = () => useContext(AISmsTemplateContext);
